export const REQUEST_STATUS_NAME_DRAFT = 'draft';
export const REQUEST_STATUS_NAME_REVISION = 'revision';
export const REQUEST_STATUS_NAME_REJECTED = 'rejected';
export const REQUEST_STATUS_NAME_MODERATOR = 'moderator';
export const REQUEST_STATUS_NAME_ADMIN_FREE = 'admin_free';
export const REQUEST_STATUS_NAME_ADMIN_QUEUE = 'admin_queue';
export const REQUEST_STATUS_NAME_LEADER = 'leader';
export const REQUEST_STATUS_NAME_PROJECT_START = 'project_start';
